import React, { useState, useEffect } from "react";
import Header from "./Header";
import axios from "axios";
import { FiX, FiPlus } from "react-icons/fi";
import { API_BASE_URL } from "../utils/apiConfig";

export default function AdvertisementPage() {
    const [devices, setDevices] = useState([]);
    const [advertisements, setAdvertisements] = useState([]);

    const [formData, setFormData] = useState({
        device_id_FK: "",
        media_type: "image",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
    });
    const [file, setFile] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchDevices();
        fetchAdvertisements();
    }, []);

    const fetchDevices = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${API_BASE_URL}/api/devices`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Handle if the data is just an array instead of standard response format
            if (res.data && Array.isArray(res.data)) {
                setDevices(res.data);
            } else if (res.data.status) {
                setDevices(res.data.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const fetchAdvertisements = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${API_BASE_URL}/api/advertisements`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.status) {
                setAdvertisements(res.data.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            alert("Please select a file");
            return;
        }
        const data = new FormData();
        Object.keys(formData).forEach(key => data.append(key, formData[key]));
        data.append("media_file", file);

        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(`${API_BASE_URL}/api/advertisements`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.data.status) {
                alert("Advertisement created!");
                setShowModal(false);
                fetchAdvertisements();
            }
        } catch (err) {
            console.error(err);
            alert("Error saving advertisement");
        }
    };

    const handleDelete = async (ad_id) => {
        if (!window.confirm("Are you sure?")) return;
        try {
            const token = localStorage.getItem("token");
            const res = await axios.delete(`${API_BASE_URL}/api/advertisements/${ad_id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.status) {
                fetchAdvertisements();
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="bg-black min-h-screen text-white p-6">
            <Header />

            <div className="mt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div>
                    <h2 className="text-xl font-bold text-white">Ads Overview</h2>
                    <p className="text-gray-500 text-xs mt-1">Manage advertisement media and schedules</p>
                </div>
            </div>

            <div className="mt-8 flex justify-between items-center bg-[#1b1d1a] p-6 rounded-t-2xl border border-gray-800 border-b-0 shadow-xl">
                <div>
                    <h2 className="text-2xl font-bold text-green-400">Manage Advertisements</h2>
                    <p className="text-gray-500 text-sm mt-1">View and manage scheduled ads across devices</p>
                </div>
                <button
                    onClick={() => setShowModal(true)}
                    className="flex items-center gap-2 px-4 h-10 bg-green-500 hover:bg-green-400 text-black font-bold rounded-xl transition shadow-lg shadow-green-500/20 mb-auto"
                >
                    <FiPlus size={18} /> Create Add Ads
                </button>
            </div>

            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
                    <div className="bg-[#1b1d1a] border border-gray-800 rounded-2xl w-full max-w-2xl overflow-hidden shadow-2xl relative">
                        <div className="flex justify-between items-center p-6 border-b border-gray-800">
                            <h2 className="text-xl font-bold text-white">Create New Advertisement</h2>
                            <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-white transition">
                                <FiX size={24} />
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">Device</label>
                                <select name="device_id_FK" value={formData.device_id_FK} onChange={handleChange} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none" required>
                                    <option value="">Select Device</option>
                                    {devices.map(d => (
                                        <option key={d.device_id_PK} value={d.device_id_PK}>{d.device_name || d.device_id_PK}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">Media Type</label>
                                <select name="media_type" value={formData.media_type} onChange={handleChange} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none">
                                    <option value="image">Image</option>
                                    <option value="video">Video</option>
                                    <option value="poster">Poster</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">Start Date</label>
                                <input type="date" name="start_date" value={formData.start_date} onChange={handleChange} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none" required />
                            </div>

                            <div>
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">End Date</label>
                                <input type="date" name="end_date" value={formData.end_date} onChange={handleChange} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none" required />
                            </div>

                            <div>
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">Start Time</label>
                                <input type="time" name="start_time" value={formData.start_time} onChange={handleChange} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none" required />
                            </div>

                            <div>
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">End Time</label>
                                <input type="time" name="end_time" value={formData.end_time} onChange={handleChange} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none" required />
                            </div>

                            <div className="md:col-span-2">
                                <label className="block text-gray-400 text-xs font-semibold uppercase tracking-wider mb-2">Upload File</label>
                                <input type="file" onChange={(e) => setFile(e.target.files[0])} className="w-full px-4 py-3 bg-black/40 border border-gray-700 rounded-xl text-white focus:ring-1 focus:ring-green-500 outline-none file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-green-500/10 file:text-green-500 hover:file:bg-green-500/20" required />
                            </div>

                            <div className="md:col-span-2 mt-4 flex justify-end gap-3 pt-4 border-t border-gray-800">
                                <button type="button" onClick={() => setShowModal(false)} className="px-6 py-3 bg-transparent text-gray-400 hover:text-white font-bold rounded-xl transition">
                                    Cancel
                                </button>
                                <button type="submit" className="px-6 py-3 bg-green-500 hover:bg-green-400 text-black font-bold rounded-xl transition shadow-lg shadow-green-500/20">
                                    Save Advertisement
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <div className="bg-[#1b1d1a] p-6 pt-0 rounded-b-2xl border border-gray-800 border-t-0 shadow-xl">
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm text-gray-300">
                        <thead className="bg-[#222] text-gray-400">
                            <tr>
                                <th className="p-3">Device ID</th>
                                <th className="p-3">Media</th>
                                <th className="p-3">Type</th>
                                <th className="p-3">Date Range</th>
                                <th className="p-3">Time Range</th>
                                <th className="p-3">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {advertisements.map(ad => (
                                <tr key={ad.ad_id_PK} className="border-b border-gray-800 hover:bg-[#1a1a1a]">
                                    <td className="p-3">{ad.device_name || ad.device_id_FK}</td>
                                    <td className="p-3">
                                        {ad.media_type === 'video' ? 'Video' : <img src={ad.media_url} alt="ad" className="h-10 w-10 object-cover" />}
                                    </td>
                                    <td className="p-3 capitalize">{ad.media_type}</td>
                                    <td className="p-3">{new Date(ad.start_date).toLocaleDateString()} - {new Date(ad.end_date).toLocaleDateString()}</td>
                                    <td className="p-3">{ad.start_time} - {ad.end_time}</td>
                                    <td className="p-3">
                                        <button onClick={() => handleDelete(ad.ad_id_PK)} className="text-red-500 hover:text-red-400">Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
